export const mainLandingFallback = {
  id: 1,
  Header: 'Официальный магазин \nприложений для Android',
  Subheader: 'Безопасный доступ к популярным \nиграм и приложениям',
  MiniSelections:
    'ru.sberbankmobile,com.idamob.tinkoff.android,ru.rostel,com.wildberries.ru,com.vkontakte.android,com.tanksblitz,ru.goods.marketplace,com.uma.musicvk,ru.dublgis.dgismobile,com.avito.android',
  GamesOfTheMonthSelection:
    'com.tanksblitz,com.roblox.client,com.jcg.Boysword,com.matreshkarp.game,com.yandex.plus.game.city,com.rstgames.durak.rustore,com.gamemisctop.busSimulator3D,com.jetliberty.san_andreas_city_police_car,com.animan_publishing.diamond_dungeon,com.ZtepGC.EscapeFr',
  instructionHowToStructuredData: null,
  DownloadButton: 'Скачать RuStore',
  Metadata: {
    id: 1,
    Title:
      'RuStore официальный магазин приложений для Android - Гарантированно безопасные приложения',
    Description:
      'Получите доступ к множеству приложений и игр в РуСтор, загружайте безопасно и удобно. Ручная модерация и безопасные платежи. При поддержке Минцифры России.',
    NoIndex: false,
    CanonicalLink: null,
    StructuredData: null,
    OpenGraphEntries: [
      {
        id: 1,
        TagName: 'site_name',
        Value: 'RuStore',
      },
      {
        id: 2,
        TagName: 'url',
        Value: 'https://www.rustore.ru/',
      },
    ],
    TwitterEntries: [],
  },
  LogoWall: {
    id: 1,
    LogoWallMarque: [
      {
        id: 1,
        MarqueSpeed: 3,
        LogoWallLogo: [
          {
            id: 1,
            href: 'https://www.rustore.ru/catalog/app/ru.ozon.app.android',
            isTargetBlank: false,
            Logo: {
              id: 11,
              name: 'ozon.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/ozon_af00f6cdf0.png',
            },
          },
          {
            id: 2,
            href: 'https://www.rustore.ru/catalog/app/ru.rostel',
            isTargetBlank: false,
            Logo: {
              id: 14,
              name: 'gosuslugi.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/gosuslugi_1864ca586d.png',
            },
          },
          {
            id: 3,
            href: 'https://www.rustore.ru/catalog/app/ru.nspk.mirpay',
            isTargetBlank: false,
            Logo: {
              id: 19,
              name: 'mir.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/mir_d793c2f931.png',
            },
          },
          {
            id: 4,
            href: 'https://www.rustore.ru/catalog/app/com.vk.vkvideo',
            isTargetBlank: false,
            Logo: {
              id: 714,
              name: 'vk_video.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/vk_video_1ccac8ba52.png',
            },
          },
          {
            id: 6,
            href: 'https://www.rustore.ru/catalog/app/ru.mail.mailapp',
            isTargetBlank: false,
            Logo: {
              id: 3130,
              name: 'Mail.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/Mail_652c632dad.png',
            },
          },
          {
            id: 5,
            href: 'https://www.rustore.ru/catalog/app/com.blinkmap.rs',
            isTargetBlank: false,
            Logo: {
              id: 225,
              name: 'Blink_App_Icon.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/Blink_App_Icon_b2a3ac91b3.png',
            },
          },
          {
            id: 7,
            href: 'https://www.rustore.ru/catalog/app/com.yandex.browser',
            isTargetBlank: false,
            Logo: {
              id: 13,
              name: 'yandex_browser.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/yandex_browser_bc580a187e.png',
            },
          },
          {
            id: 35,
            href: 'https://www.rustore.ru/catalog/app/ru.dublgis.dgismobile',
            isTargetBlank: false,
            Logo: {
              id: 241,
              name: '2GIS_app icon.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/2_GIS_app_icon_e65f7cf40d.png',
            },
          },
        ],
      },
      {
        id: 2,
        MarqueSpeed: 2,
        LogoWallLogo: [
          {
            id: 8,
            href: 'https://www.rustore.ru/catalog/app/com.allgoritm.youla',
            isTargetBlank: false,
            Logo: {
              id: 18,
              name: 'yula.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/yula_d3646df79e.png',
            },
          },
          {
            id: 9,
            href: 'https://www.rustore.ru/catalog/app/ru.alfabank.mobile.android',
            isTargetBlank: false,
            Logo: {
              id: 6,
              name: 'alfa_bank.png',
              url: 'https://static.rustore.ru/rustore-strapi/8/alfa_bank_c65e17f5ff.png',
            },
          },
          {
            id: 10,
            href: 'https://www.rustore.ru/catalog/app/ru.sberbankmobile',
            isTargetBlank: false,
            Logo: {
              id: 22,
              name: 'sber.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/sber_8354553273.png',
            },
          },
          {
            id: 11,
            href: 'https://www.rustore.ru/catalog/app/ru.megamarket.marketplace',
            isTargetBlank: false,
            Logo: {
              id: 63,
              name: 'SberMarket.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/Sber_Market_9071f0f89f.png',
            },
          },
          {
            id: 12,
            href: 'https://www.rustore.ru/catalog/app/com.idamob.tinkoff.android',
            isTargetBlank: false,
            Logo: {
              id: 1914,
              name: 'T-Bank_Icon.png',
              url: 'https://static.rustore.ru/rustore-strapi/7/T_Bank_Icon_2ad65b69c0.png',
            },
          },
          {
            id: 13,
            href: 'https://www.rustore.ru/catalog/app/ru.rt.video.app.mobile',
            isTargetBlank: false,
            Logo: {
              id: 3128,
              name: 'wink.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/wink_c01c37075e.png',
            },
          },
          {
            id: 14,
            href: 'https://www.rustore.ru/catalog/app/ru.more.play',
            isTargetBlank: false,
            Logo: {
              id: 3129,
              name: 'okko.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/okko_11093b9dd1.png',
            },
          },
          {
            id: 34,
            href: 'https://www.rustore.ru/catalog/app/com.vk.love',
            isTargetBlank: false,
            Logo: {
              id: 238,
              name: 'VK znakomstva_app icon.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/VK_znakomstva_app_icon_5358b68274.png',
            },
          },
        ],
      },
      {
        id: 4,
        MarqueSpeed: 1,
        LogoWallLogo: [
          {
            id: 15,
            href: 'https://www.rustore.ru/catalog/app/ru.beru.android',
            isTargetBlank: false,
            Logo: {
              id: 1932,
              name: 'Ya_Market_Icon.png',
              url: 'https://static.rustore.ru/rustore-strapi/7/Ya_Market_Icon_db6be4957c.png',
            },
          },
          {
            id: 16,
            href: 'https://www.rustore.ru/catalog/app/com.wildberries.ru',
            isTargetBlank: false,
            Logo: {
              id: 3131,
              name: 'WB.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/WB_a9123bdd41.png',
            },
          },
          {
            id: 17,
            href: 'https://www.rustore.ru/catalog/app/com.avito.android',
            isTargetBlank: false,
            Logo: {
              id: 10,
              name: 'avito.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/avito_9e69b42924.png',
            },
          },
          {
            id: 18,
            href: 'https://www.rustore.ru/catalog/app/com.tanksblitz',
            isTargetBlank: false,
            Logo: {
              id: 5246,
              name: 'Tanks_Blitz_Icon.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/Tanks_Blitz_Icon_b8e2b3a0ae.png',
            },
          },
          {
            id: 19,
            href: 'https://www.rustore.ru/catalog/app/ru.mts.mymts',
            isTargetBlank: false,
            Logo: {
              id: 29,
              name: 'mts.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/mts_6059fd5b1b.png',
            },
          },
          {
            id: 20,
            href: 'https://www.rustore.ru/catalog/app/ru.ok.android',
            isTargetBlank: false,
            Logo: {
              id: 26,
              name: 'odnoklassniki.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/odnoklassniki_436780aaac.png',
            },
          },
          {
            id: 21,
            href: 'https://www.rustore.ru/catalog/app/ru.yandex.yandexmaps',
            isTargetBlank: false,
            Logo: {
              id: 28,
              name: 'yandex_karti.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/yandex_karti_99583895c6.png',
            },
          },
          {
            id: 36,
            href: 'https://www.rustore.ru/catalog/app/com.icemobile.lenta.prod',
            isTargetBlank: false,
            Logo: {
              id: 237,
              name: 'Lenta_app icon.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/Lenta_app_icon_06c154fdcd.png',
            },
          },
        ],
      },
      {
        id: 3,
        MarqueSpeed: 0,
        LogoWallLogo: [
          {
            id: 22,
            href: 'https://www.rustore.ru/catalog/app/com.vkontakte.android',
            isTargetBlank: false,
            Logo: {
              id: 17,
              name: 'vk.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/vk_bef8f948e2.png',
            },
          },
          {
            id: 23,
            href: 'https://www.rustore.ru/catalog/app/ru.yandex.yandexnavi',
            isTargetBlank: false,
            Logo: {
              id: 33,
              name: 'yandex_navigator.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/yandex_navigator_aaed28c2cb.png',
            },
          },
          {
            id: 24,
            href: 'https://www.rustore.ru/catalog/app/com.deliveryclub',
            isTargetBlank: false,
            Logo: {
              id: 7,
              name: 'delivery_club.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/delivery_club_75ca82ecb8.png',
            },
          },
          {
            id: 25,
            href: 'https://www.rustore.ru/catalog/app/video.like.rustore',
            isTargetBlank: false,
            Logo: {
              id: 9,
              name: 'likee.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/likee_cbe1de4189.png',
            },
          },
          {
            id: 26,
            href: 'https://www.rustore.ru/catalog/app/ru.yandex.taxi',
            isTargetBlank: false,
            Logo: {
              id: 16,
              name: 'yandex_go.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/yandex_go_28f82f0312.png',
            },
          },
          {
            id: 27,
            href: 'https://www.rustore.ru/catalog/app/ru.sbcs.store',
            isTargetBlank: false,
            Logo: {
              id: 23,
              name: 'samokat.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/samokat_ed6fa41cff.png',
            },
          },
          {
            id: 28,
            href: 'https://www.rustore.ru/catalog/app/ru.tander.magnit',
            isTargetBlank: false,
            Logo: {
              id: 39,
              name: 'Magnit_App Icon.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/Magnit_App_Icon_fbf23e5a0b.png',
            },
          },
          {
            id: 37,
            href: 'https://www.rustore.ru/catalog/app/ru.nspk.sbpay',
            isTargetBlank: false,
            Logo: {
              id: 236,
              name: 'SBPay_app icon.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/SB_Pay_app_icon_ace7d6683d.png',
            },
          },
        ],
      },
    ],
  },
  RuStoreOpenForm: {
    id: 1,
    title: 'Предложить приложение',
    submitButtonText: 'Отправить',
    linkHint: 'Подойдет ссылка на APK файл или ссылка на любой ресурс',
    name: {
      id: 211,
      label: 'Название',
      placeholder: 'Как называется приложение',
      optional: false,
      inputName: 'name',
      isTextArea: false,
      minLength: 1,
      maxLength: 50,
      valueType: 'plaintext',
    },
    link: {
      id: 212,
      label: 'Ссылка на приложение',
      placeholder: 'Где можно найти приложение',
      optional: false,
      inputName: 'link',
      isTextArea: false,
      minLength: 1,
      maxLength: 200,
      valueType: 'url',
    },
    description: {
      id: 213,
      label: 'Краткое описание',
      placeholder: 'Расскажите о приложении',
      optional: false,
      inputName: 'description',
      isTextArea: true,
      minLength: 1,
      maxLength: 80,
      valueType: 'plaintext',
    },
    type: {
      id: 214,
      label: 'Тип',
      placeholder: 'type',
      optional: false,
      inputName: 'type',
      isTextArea: true,
      minLength: 1,
      maxLength: 200,
      valueType: 'plaintext',
    },
  },
  RedesignAdvantages: [
    {
      id: 1,
      title: 'Гарантия \nбезопасности',
      subtitle: 'Проверка приложений модерацией \nи антивирусом',
      backgroundColor: '#00B594',
      logo: {
        id: 1544,
        name: 'shelter.png',
        url: 'https://static.rustore.ru/rustore-strapi/7/shelter_d7f6c5442c.png',
      },
      titleLogo: {
        id: 1525,
        name: 'Frame_1321315620_a1063bf518_76e65a3419.svg',
        url: 'https://static.rustore.ru/rustore-strapi/6/Frame_1321315620_a1063bf518_76e65a3419_3aad1d48ab.svg',
      },
    },
    {
      id: 2,
      title: 'Доступ к приложениям\nбез ограничений',
      subtitle: 'Всё под рукой — от мобильных банков до игровых хитов',
      backgroundColor: '#0077FF',
      logo: {
        id: 1545,
        name: 'screens.png',
        url: 'https://static.rustore.ru/rustore-strapi/6/screens_31a834e4bf.png',
      },
      titleLogo: null,
    },
    {
      id: 3,
      title: 'Удобная оплата \nподписок и покупок',
      subtitle: 'Платите картой, по СБП, с баланса телефона и не только',
      backgroundColor: '#9339D1',
      logo: {
        id: 1546,
        name: 'rouble.png',
        url: 'https://static.rustore.ru/rustore-strapi/6/rouble_84939b67e9.png',
      },
      titleLogo: null,
    },
  ],
  RedesignAdvantagesInstruction: {
    id: 1,
    title: 'Наведите камеру\nдля загрузки Rustore',
    subtitle: 'Поддерживаются устройства от',
    qrCode: {
      id: 3300,
      name: 'QR-code.svg',
      url: 'https://static.rustore.ru/rustore-strapi/6/QR_code_28c023f346.svg',
    },
    OSList: [
      {
        id: 1,
        OSName: 'android 7.0',
        OSIcon: {
          id: 1526,
          name: 'Android_47785be0fa_07bd94a084.svg',
          url: 'https://static.rustore.ru/rustore-strapi/6/Android_47785be0fa_07bd94a084_6f8dbf31fd.svg',
        },
      },
      {
        id: 2,
        OSName: 'Harmony OS 3',
        OSIcon: {
          id: 1527,
          name: 'HMOS_Logo_Icon_08fde76bf0_51b2e3f7d0.svg',
          url: 'https://static.rustore.ru/rustore-strapi/6/HMOS_Logo_Icon_08fde76bf0_51b2e3f7d0_7625feabb8.svg',
        },
      },
    ],
  },
  GamesOfTheMonth: {
    id: 1,
    gamesSelections:
      'com.tanksblitz,com.roblox.client,com.jcg.Boysword,com.matreshkarp.game,com.yandex.plus.game.city,com.rstgames.durak.rustore,com.gamemisctop.busSimulator3D,com.jetliberty.san_andreas_city_police_car,com.animan_publishing.diamond_dungeon,com.ZtepGC.EscapeFr',
    title: 'Игры месяца',
    buttonText: 'Все игры',
    backgroundImage: {
      id: 1572,
      name: 'Image (4).jpg',
      url: 'https://static.rustore.ru/rustore-strapi/6/Image_4_6a2a1bc0e7.jpg',
    },
  },
  TVBlock: {
    id: 1,
    title: 'RuStore для ТВ',
    subtitle:
      'Приложения ТВ-каналов, стриминговые сервисы, игры и программы видеоконференций',
    buttonText: 'Скачать RuStore для ТВ',
    targetBlankButton: false,
    buttonHref: 'https://www.rustore.ru/tv',
    backgroundImage: {
      id: 1543,
      name: 'tv-image.png',
      url: 'https://static.rustore.ru/rustore-strapi/6/tv_image_01c8d593de.png',
    },
    tvApps: [
      {
        id: 35,
        href: 'https://www.rustore.ru/catalog/app/com.vk.tvt',
        isTargetBlank: false,
        backgroundImage: {
          id: 566,
          name: 'Rectangle 7.svg',
          width: 224,
          height: 128,
          url: 'https://static.rustore.ru/rustore-strapi/6/VK_a79aa8327f.png',
        },
      },
      {
        id: 36,
        href: 'https://www.rustore.ru/catalog/app/ru.ivi.client',
        isTargetBlank: false,
        backgroundImage: {
          id: 568,
          name: 'image 261 (1).svg',
          width: 224,
          height: 128,
          url: 'https://static.rustore.ru/rustore-strapi/7/ivi_705787e240.png',
        },
      },
      {
        id: 39,
        href: 'https://www.rustore.ru/catalog/app/ru.kinopoisk.tv',
        isTargetBlank: false,
        backgroundImage: {
          id: 566,
          name: 'Rectangle 7.svg',
          width: 224,
          height: 128,
          url: 'https://static.rustore.ru/rustore-strapi/8/Aspect_Ratio_d7e3065797.png',
        },
      },
      {
        id: 40,
        href: 'https://www.rustore.ru/catalog/app/one.premier.rustoretv',
        isTargetBlank: false,
        backgroundImage: {
          id: 565,
          name: 'Rectangle 2.svg',
          width: 224,
          height: 128,
          url: 'https://static.rustore.ru/rustore-strapi/6/premier_e0bb75fa82.png',
        },
      },
      {
        id: 38,
        href: 'https://www.rustore.ru/catalog/app/tv.okko.androidtv',
        isTargetBlank: false,
        backgroundImage: {
          id: 566,
          name: 'Rectangle 7.svg',
          width: 224,
          height: 128,
          url: 'https://static.rustore.ru/rustore-strapi/6/okko_cd0f5b702b.png',
        },
      },
    ],
  },
  searchBlock: {
    id: 1,
    title: 'Найдите приложение для себя',
    placeholder: 'Поиск приложений и игр',
    searchButtonText: 'Найти',
    clearHistoryButton: 'Очистить историю',
  },
  webCatalogCategories: {
    gamesTitle: 'Проведите время с удовольствием',
    gamesButton: 'Все игры',
    appsTitle: 'Всё для удобства',
    appsButton: 'Все приложения',
  },
  blog: {
    title: 'Блог',
  },
  SEOTags: {
    id: 1,
    title: 'Интересные \nтематики',
    links: [
      {
        title: 'Однопользовательская игра',
        href: 'https://www.rustore.ru/catalog/tag/44',
      },
      {
        title: 'Офлайн',
        href: 'https://www.rustore.ru/catalog/tag/45',
      },
      {
        title: 'Самосовершенствование',
        href: 'https://www.rustore.ru/catalog/tag/109',
      },
      {
        title: 'Стиль жизни',
        href: 'https://www.rustore.ru/catalog/tag/116',
      },
      {
        title: 'Личные помощники',
        href: 'https://www.rustore.ru/catalog/tag/150',
      },
      {
        title: 'Логическая игра',
        href: 'https://www.rustore.ru/catalog/tag/35',
      },
      {
        title: 'Работа',
        href: 'https://www.rustore.ru/catalog/tag/115',
      },
      {
        title: 'Социальные',
        href: 'https://www.rustore.ru/catalog/tag/117',
      },
      {
        title: 'Интеллектуальные игры',
        href: 'https://www.rustore.ru/catalog/tag/24',
      },
      {
        title: 'Гиперказуальная игра',
        href: 'https://www.rustore.ru/catalog/tag/14',
      },
    ],
  },
  kioskPreview: {
    id: 1,
    title: 'Пополняйте баланс удобно',
    subtitle:
      'Оплачивайте любимые игры и сервисы с помощью российских банковских карт',
    buttonText: 'Пополнить баланс',
    links: [
      {
        id: 22,
        href: 'https://www.rustore.ru/catalog/kiosk',
        isTargetBlank: false,
        backgroundImage: {
          url: 'https://static.rustore.ru/rustore-strapi/6/steam_8a7894d5f0.png',
        },
      },
      {
        id: 17,
        href: 'https://www.rustore.ru/catalog/kiosk',
        isTargetBlank: false,
        backgroundImage: {
          url: 'https://static.rustore.ru/rustore-strapi/6/sony_bcd0f7b9d6.png',
        },
      },
      {
        id: 20,
        href: 'https://www.rustore.ru/catalog/kiosk',
        isTargetBlank: false,
        backgroundImage: {
          url: 'https://static.rustore.ru/rustore-strapi/6/roblox_8a7b1b44da.png',
        },
      },
      {
        id: 21,
        href: 'https://www.rustore.ru/catalog/kiosk',
        isTargetBlank: false,
        backgroundImage: {
          url: 'https://static.rustore.ru/rustore-strapi/6/xbox_4fc718d3af.png',
        },
      },
      {
        id: 24,
        href: 'https://www.rustore.ru/catalog/kiosk',
        isTargetBlank: false,
        backgroundImage: {
          url: 'https://static.rustore.ru/rustore-strapi/6/pubg_9fc9e39360.png',
        },
      },
      {
        id: 19,
        href: 'https://www.rustore.ru/catalog/kiosk',
        isTargetBlank: false,
        backgroundImage: {
          url: 'https://static.rustore.ru/rustore-strapi/6/twitch_b4ff62807e.png',
        },
      },
      {
        id: 23,
        href: 'https://www.rustore.ru/catalog/kiosk',
        isTargetBlank: false,
        backgroundImage: {
          url: 'https://static.rustore.ru/rustore-strapi/6/lol_c316f72756.png',
        },
      },
      {
        id: 18,
        href: 'https://www.rustore.ru/catalog/kiosk',
        isTargetBlank: false,
        backgroundImage: {
          url: 'https://static.rustore.ru/rustore-strapi/6/minecraft_d8d46d5e03.png',
        },
      },
      {
        id: 16,
        href: 'https://www.rustore.ru/catalog/kiosk',
        isTargetBlank: false,
        backgroundImage: {
          url: 'https://static.rustore.ru/rustore-strapi/6/battlenet_e6761596a6.png',
        },
      },
    ],
  },
};

export const mainLandingEnFallback = {
  id: 1,
  Header: 'Official Android \nApp Store',
  Subheader: 'Your reliable way to Top Games \nand Apps',
  MiniSelections:
    'ru.sberbankmobile,com.idamob.tinkoff.android,ru.rostel,com.wildberries.ru,com.vkontakte.android,com.tanksblitz,ru.goods.marketplace,com.uma.musicvk,ru.dublgis.dgismobile,com.avito.android',
  GamesOfTheMonthSelection:
    'com.tanksblitz,com.roblox.client,com.jcg.Boysword,com.matreshkarp.game,com.yandex.plus.game.city,com.rstgames.durak.rustore,com.gamemisctop.busSimulator3D,com.jetliberty.san_andreas_city_police_car,com.animan_publishing.diamond_dungeon,com.ZtepGC.EscapeFr',
  DownloadButton: 'Download RuStore',
  locale: 'en',
  instructionHowToStructuredData: null,
  Metadata: {
    id: 1,
    Title:
      'RuStore официальный магазин приложений для Android - Гарантированно безопасные приложения',
    Description:
      'Получите доступ к множеству приложений и игр в РуСтор, загружайте безопасно и удобно. Ручная модерация и безопасные платежи. При поддержке Минцифры России.',
    NoIndex: false,
    CanonicalLink: null,
    StructuredData: null,
    OpenGraphEntries: [
      {
        id: 1,
        TagName: 'site_name',
        Value: 'RuStore',
      },
      {
        id: 2,
        TagName: 'url',
        Value: 'https://www.rustore.ru/',
      },
    ],
    TwitterEntries: [],
  },
  LogoWall: {
    id: 1,
    LogoWallMarque: [
      {
        id: 1,
        MarqueSpeed: 3,
        LogoWallLogo: [
          {
            id: 1,
            href: 'https://www.rustore.ru/catalog/app/ru.ozon.app.android',
            isTargetBlank: false,
            Logo: {
              id: 11,
              name: 'ozon.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/ozon_af00f6cdf0.png',
            },
          },
          {
            id: 2,
            href: 'https://www.rustore.ru/catalog/app/ru.rostel',
            isTargetBlank: false,
            Logo: {
              id: 14,
              name: 'gosuslugi.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/gosuslugi_1864ca586d.png',
            },
          },
          {
            id: 3,
            href: 'https://www.rustore.ru/catalog/app/ru.nspk.mirpay',
            isTargetBlank: false,
            Logo: {
              id: 19,
              name: 'mir.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/mir_d793c2f931.png',
            },
          },
          {
            id: 4,
            href: 'https://www.rustore.ru/catalog/app/com.vk.vkvideo',
            isTargetBlank: false,
            Logo: {
              id: 714,
              name: 'vk_video.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/vk_video_1ccac8ba52.png',
            },
          },
          {
            id: 6,
            href: 'https://www.rustore.ru/catalog/app/ru.mail.mailapp',
            isTargetBlank: false,
            Logo: {
              id: 3130,
              name: 'Mail.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/Mail_652c632dad.png',
            },
          },
          {
            id: 5,
            href: 'https://www.rustore.ru/catalog/app/com.blinkmap.rs',
            isTargetBlank: false,
            Logo: {
              id: 225,
              name: 'Blink_App_Icon.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/Blink_App_Icon_b2a3ac91b3.png',
            },
          },
          {
            id: 7,
            href: 'https://www.rustore.ru/catalog/app/com.yandex.browser',
            isTargetBlank: false,
            Logo: {
              id: 13,
              name: 'yandex_browser.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/yandex_browser_bc580a187e.png',
            },
          },
          {
            id: 35,
            href: 'https://www.rustore.ru/catalog/app/ru.dublgis.dgismobile',
            isTargetBlank: false,
            Logo: {
              id: 241,
              name: '2GIS_app icon.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/2_GIS_app_icon_e65f7cf40d.png',
            },
          },
        ],
      },
      {
        id: 2,
        MarqueSpeed: 2,
        LogoWallLogo: [
          {
            id: 8,
            href: 'https://www.rustore.ru/catalog/app/com.allgoritm.youla',
            isTargetBlank: false,
            Logo: {
              id: 18,
              name: 'yula.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/yula_d3646df79e.png',
            },
          },
          {
            id: 9,
            href: 'https://www.rustore.ru/catalog/app/ru.alfabank.mobile.android',
            isTargetBlank: false,
            Logo: {
              id: 6,
              name: 'alfa_bank.png',
              url: 'https://static.rustore.ru/rustore-strapi/8/alfa_bank_c65e17f5ff.png',
            },
          },
          {
            id: 10,
            href: 'https://www.rustore.ru/catalog/app/ru.sberbankmobile',
            isTargetBlank: false,
            Logo: {
              id: 22,
              name: 'sber.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/sber_8354553273.png',
            },
          },
          {
            id: 11,
            href: 'https://www.rustore.ru/catalog/app/ru.megamarket.marketplace',
            isTargetBlank: false,
            Logo: {
              id: 63,
              name: 'SberMarket.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/Sber_Market_9071f0f89f.png',
            },
          },
          {
            id: 12,
            href: 'https://www.rustore.ru/catalog/app/com.idamob.tinkoff.android',
            isTargetBlank: false,
            Logo: {
              id: 1914,
              name: 'T-Bank_Icon.png',
              url: 'https://static.rustore.ru/rustore-strapi/7/T_Bank_Icon_2ad65b69c0.png',
            },
          },
          {
            id: 13,
            href: 'https://www.rustore.ru/catalog/app/ru.rt.video.app.mobile',
            isTargetBlank: false,
            Logo: {
              id: 3128,
              name: 'wink.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/wink_c01c37075e.png',
            },
          },
          {
            id: 14,
            href: 'https://www.rustore.ru/catalog/app/ru.more.play',
            isTargetBlank: false,
            Logo: {
              id: 3129,
              name: 'okko.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/okko_11093b9dd1.png',
            },
          },
          {
            id: 34,
            href: 'https://www.rustore.ru/catalog/app/com.vk.love',
            isTargetBlank: false,
            Logo: {
              id: 238,
              name: 'VK znakomstva_app icon.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/VK_znakomstva_app_icon_5358b68274.png',
            },
          },
        ],
      },
      {
        id: 4,
        MarqueSpeed: 1,
        LogoWallLogo: [
          {
            id: 15,
            href: 'https://www.rustore.ru/catalog/app/ru.beru.android',
            isTargetBlank: false,
            Logo: {
              id: 1932,
              name: 'Ya_Market_Icon.png',
              url: 'https://static.rustore.ru/rustore-strapi/7/Ya_Market_Icon_db6be4957c.png',
            },
          },
          {
            id: 16,
            href: 'https://www.rustore.ru/catalog/app/com.wildberries.ru',
            isTargetBlank: false,
            Logo: {
              id: 3131,
              name: 'WB.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/WB_a9123bdd41.png',
            },
          },
          {
            id: 17,
            href: 'https://www.rustore.ru/catalog/app/com.avito.android',
            isTargetBlank: false,
            Logo: {
              id: 10,
              name: 'avito.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/avito_9e69b42924.png',
            },
          },
          {
            id: 18,
            href: 'https://www.rustore.ru/catalog/app/com.tanksblitz',
            isTargetBlank: false,
            Logo: {
              id: 5246,
              name: 'Tanks_Blitz_Icon.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/Tanks_Blitz_Icon_b8e2b3a0ae.png',
            },
          },
          {
            id: 19,
            href: 'https://www.rustore.ru/catalog/app/ru.mts.mymts',
            isTargetBlank: false,
            Logo: {
              id: 29,
              name: 'mts.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/mts_6059fd5b1b.png',
            },
          },
          {
            id: 20,
            href: 'https://www.rustore.ru/catalog/app/ru.ok.android',
            isTargetBlank: false,
            Logo: {
              id: 26,
              name: 'odnoklassniki.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/odnoklassniki_436780aaac.png',
            },
          },
          {
            id: 21,
            href: 'https://www.rustore.ru/catalog/app/ru.yandex.yandexmaps',
            isTargetBlank: false,
            Logo: {
              id: 28,
              name: 'yandex_karti.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/yandex_karti_99583895c6.png',
            },
          },
          {
            id: 36,
            href: 'https://www.rustore.ru/catalog/app/com.icemobile.lenta.prod',
            isTargetBlank: false,
            Logo: {
              id: 237,
              name: 'Lenta_app icon.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/Lenta_app_icon_06c154fdcd.png',
            },
          },
        ],
      },
      {
        id: 3,
        MarqueSpeed: 0,
        LogoWallLogo: [
          {
            id: 22,
            href: 'https://www.rustore.ru/catalog/app/com.vkontakte.android',
            isTargetBlank: false,
            Logo: {
              id: 17,
              name: 'vk.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/vk_bef8f948e2.png',
            },
          },
          {
            id: 23,
            href: 'https://www.rustore.ru/catalog/app/ru.yandex.yandexnavi',
            isTargetBlank: false,
            Logo: {
              id: 33,
              name: 'yandex_navigator.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/yandex_navigator_aaed28c2cb.png',
            },
          },
          {
            id: 24,
            href: 'https://www.rustore.ru/catalog/app/com.deliveryclub',
            isTargetBlank: false,
            Logo: {
              id: 7,
              name: 'delivery_club.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/delivery_club_75ca82ecb8.png',
            },
          },
          {
            id: 25,
            href: 'https://www.rustore.ru/catalog/app/video.like.rustore',
            isTargetBlank: false,
            Logo: {
              id: 9,
              name: 'likee.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/likee_cbe1de4189.png',
            },
          },
          {
            id: 26,
            href: 'https://www.rustore.ru/catalog/app/ru.yandex.taxi',
            isTargetBlank: false,
            Logo: {
              id: 16,
              name: 'yandex_go.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/yandex_go_28f82f0312.png',
            },
          },
          {
            id: 27,
            href: 'https://www.rustore.ru/catalog/app/ru.sbcs.store',
            isTargetBlank: false,
            Logo: {
              id: 23,
              name: 'samokat.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/samokat_ed6fa41cff.png',
            },
          },
          {
            id: 28,
            href: 'https://www.rustore.ru/catalog/app/ru.tander.magnit',
            isTargetBlank: false,
            Logo: {
              id: 39,
              name: 'Magnit_App Icon.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/Magnit_App_Icon_fbf23e5a0b.png',
            },
          },
          {
            id: 37,
            href: 'https://www.rustore.ru/catalog/app/ru.nspk.sbpay',
            isTargetBlank: false,
            Logo: {
              id: 236,
              name: 'SBPay_app icon.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/SB_Pay_app_icon_ace7d6683d.png',
            },
          },
        ],
      },
    ],
  },
  RuStoreOpenForm: {
    id: 1,
    title: 'Suggest an App',
    submitButtonText: 'Отправить',
    linkHint: 'Подойдет ссылка на APK файл или ссылка на любой ресурс',
    name: {
      id: 211,
      label: 'Название',
      placeholder: 'Как называется приложение',
      optional: false,
      inputName: 'name',
      isTextArea: false,
      minLength: 1,
      maxLength: 50,
      valueType: 'plaintext',
    },
    link: {
      id: 212,
      label: 'Ссылка на приложение',
      placeholder: 'Где можно найти приложение',
      optional: false,
      inputName: 'link',
      isTextArea: false,
      minLength: 1,
      maxLength: 200,
      valueType: 'url',
    },
    description: {
      id: 213,
      label: 'Краткое описание',
      placeholder: 'Расскажите о приложении',
      optional: false,
      inputName: 'description',
      isTextArea: true,
      minLength: 1,
      maxLength: 80,
      valueType: 'plaintext',
    },
    type: {
      id: 214,
      label: 'Тип',
      placeholder: 'type',
      optional: false,
      inputName: 'type',
      isTextArea: true,
      minLength: 1,
      maxLength: 200,
      valueType: 'plaintext',
    },
  },
  SitemapConfig: {
    id: 4,
    defaultPriority: null,
    defaultChangefreq: null,
    entries: [],
    exclusions: [
      {
        id: 1,
        path: '/offers/ad_info',
      },
      {
        id: 2,
        path: '/offers/ad_info_vtb',
      },
    ],
  },
  RedesignAdvantages: [
    {
      id: 34,
      title: 'Secure Downloads, \nEvery Time',
      subtitle: 'Every app is verified by moderators \nand scanned for safety',
      backgroundColor: '#00B594',
      logo: {
        id: 543,
        name: 'shhit2_1_0fc52d0643.png',
        width: 240,
        height: 200,
        url: 'https://platform-s3.dev.rustore.devmail.ru/rustore-strapi-stage/shhit2_1_0fc52d0643_162ebe6957.png',
      },
      titleLogo: {
        id: 542,
        name: 'Frame_1321315620_a1063bf518.svg',
        width: 128,
        height: 24,
        url: 'https://platform-s3.dev.rustore.devmail.ru/rustore-strapi-stage/Frame_1321315620_a1063bf518_76e65a3419.svg',
      },
    },
    {
      id: 36,
      title: 'Apps Without \nLimits',
      subtitle:
        'Discover everything you need — from mobile \nbanking to gaming hits',
      backgroundColor: '#0077FF',
      logo: {
        id: 544,
        name: '32_3_1_07b06a45c4.png',
        width: 240,
        height: 194,
        url: 'https://platform-s3.dev.rustore.devmail.ru/rustore-strapi-stage/32_3_1_07b06a45c4_54d223801d.png',
      },
      titleLogo: null,
    },
    {
      id: 35,
      title: 'Subscriptions and \nPurchases made easy',
      subtitle: 'Pay by card, Faster Payments (SBP), phone \ncredit and more',
      backgroundColor: '#9339D1',
      logo: {
        id: 545,
        name: 'Group_1321315585_791f2f7b61.png',
        width: 240,
        height: 200,
        url: 'https://platform-s3.dev.rustore.devmail.ru/rustore-strapi-stage/Group_1321315585_791f2f7b61_bef34cabaf.png',
      },
      titleLogo: null,
    },
  ],
  RedesignAdvantagesInstruction: {
    id: 34,
    title: 'Use Your Camera \nto Download RuStore',
    subtitle: 'Compatible\nwith',
    qrCode: {
      id: 563,
      name: 'qr-code.svg',
      width: 160,
      height: 160,
      url: 'https://platform-s3.dev.rustore.devmail.ru/rustore-strapi-stage/qr_code_fff39c62ec.svg',
    },
    OSList: [
      {
        id: 34,
        OSName: 'Android 7.0',
        OSIcon: {
          id: 541,
          name: 'Android_47785be0fa.svg',
          width: 28,
          height: 28,
          size: 1.66,
          url: 'https://platform-s3.dev.rustore.devmail.ru/rustore-strapi-stage/Android_47785be0fa_07bd94a084.svg',
        },
      },
      {
        id: 35,
        OSName: 'Harmony OS 3',
        OSIcon: {
          id: 540,
          name: 'HMOS_Logo_Icon_08fde76bf0.svg',
          width: 24,
          height: 24,
          url: 'https://platform-s3.dev.rustore.devmail.ru/rustore-strapi-stage/HMOS_Logo_Icon_08fde76bf0_51b2e3f7d0.svg',
        },
      },
    ],
  },
  GamesOfTheMonth: {
    id: 1,
    gamesSelections:
      'com.tanksblitz,com.roblox.client,com.jcg.Boysword,com.matreshkarp.game,com.yandex.plus.game.city,com.rstgames.durak.rustore,com.gamemisctop.busSimulator3D,com.jetliberty.san_andreas_city_police_car,com.animan_publishing.diamond_dungeon,com.ZtepGC.EscapeFr',
    title: 'Top Games This Month',
    buttonText: 'Explore All Games',
    backgroundImage: {
      id: 1572,
      name: 'Image (4).jpg',
      width: 2784,
      height: 1600,
      url: 'https://static.rustore.ru/rustore-strapi/6/Image_4_6a2a1bc0e7.jpg',
    },
  },
  TVBlock: {
    id: 34,
    title: 'RuStore for TV',
    subtitle:
      'Apps for TV Channels, Streaming Services, Games, \nand Video Conferencing',
    buttonText: 'Download RuStore for TV',
    targetBlankButton: false,
    buttonHref: 'https://www.rustore.ru/tv',
    backgroundImage: {
      id: 575,
      name: '23 3.svg',
      width: 240,
      height: 200,
      url: 'https://platform-s3.dev.rustore.devmail.ru/rustore-strapi-stage/23_3_4de4bff2c1.svg',
    },
    tvApps: [
      {
        id: 35,
        href: 'https://www.rustore.ru/catalog/app/com.vk.tvt',
        isTargetBlank: false,
        backgroundImage: {
          id: 566,
          name: 'Rectangle 7.svg',
          width: 224,
          height: 128,
          url: 'https://static.rustore.ru/rustore-strapi/6/VK_a79aa8327f.png',
        },
      },
      {
        id: 36,
        href: 'https://www.rustore.ru/catalog/app/ru.ivi.client',
        isTargetBlank: false,
        backgroundImage: {
          id: 568,
          name: 'image 261 (1).svg',
          width: 224,
          height: 128,
          url: 'https://static.rustore.ru/rustore-strapi/7/ivi_705787e240.png',
        },
      },
      {
        id: 39,
        href: 'https://www.rustore.ru/catalog/app/ru.kinopoisk.tv',
        isTargetBlank: false,
        backgroundImage: {
          id: 566,
          name: 'Rectangle 7.svg',
          width: 224,
          height: 128,
          url: 'https://static.rustore.ru/rustore-strapi/8/Aspect_Ratio_d7e3065797.png',
        },
      },
      {
        id: 40,
        href: 'https://www.rustore.ru/catalog/app/one.premier.rustoretv',
        isTargetBlank: false,
        backgroundImage: {
          id: 565,
          name: 'Rectangle 2.svg',
          width: 224,
          height: 128,
          url: 'https://static.rustore.ru/rustore-strapi/6/premier_e0bb75fa82.png',
        },
      },
      {
        id: 38,
        href: 'https://www.rustore.ru/catalog/app/tv.okko.androidtv',
        isTargetBlank: false,
        backgroundImage: {
          id: 566,
          name: 'Rectangle 7.svg',
          width: 224,
          height: 128,
          url: 'https://static.rustore.ru/rustore-strapi/6/okko_cd0f5b702b.png',
        },
      },
    ],
  },
  searchBlock: {
    id: 2,
    title: 'Find the app that will \nwork best for you',
    placeholder: 'Search for apps and games',
    searchButtonText: 'Search',
    clearHistoryButton: 'Clear history',
  },
};

export const mainLandingZhFallback = {
  id: 1,
  Header: '官方Android系统 \n应用商店',
  Subheader: '安全访问流行的游戏和应用程序',
  MiniSelections:
    'ru.sberbankmobile,com.idamob.tinkoff.android,ru.rostel,com.wildberries.ru,com.vkontakte.android,com.tanksblitz,ru.goods.marketplace,com.uma.musicvk,ru.dublgis.dgismobile,com.avito.android',
  GamesOfTheMonthSelection:
    'com.tanksblitz,com.roblox.client,com.jcg.Boysword,com.matreshkarp.game,com.yandex.plus.game.city,com.rstgames.durak.rustore,com.gamemisctop.busSimulator3D,com.jetliberty.san_andreas_city_police_car,com.animan_publishing.diamond_dungeon,com.ZtepGC.EscapeFr',
  DownloadButton: '下载RuStore',
  locale: 'zh',
  instructionHowToStructuredData: null,
  Metadata: {
    id: 1,
    Title:
      'RuStore официальный магазин приложений для Android - Гарантированно безопасные приложения',
    Description:
      'Получите доступ к множеству приложений и игр в РуСтор, загружайте безопасно и удобно. Ручная модерация и безопасные платежи. При поддержке Минцифры России.',
    NoIndex: false,
    CanonicalLink: null,
    StructuredData: null,
    OpenGraphEntries: [
      {
        id: 1,
        TagName: 'site_name',
        Value: 'RuStore',
      },
      {
        id: 2,
        TagName: 'url',
        Value: 'https://www.rustore.ru/',
      },
    ],
    TwitterEntries: [],
  },
  LogoWall: {
    id: 1,
    LogoWallMarque: [
      {
        id: 1,
        MarqueSpeed: 3,
        LogoWallLogo: [
          {
            id: 1,
            href: 'https://www.rustore.ru/catalog/app/ru.ozon.app.android',
            isTargetBlank: false,
            Logo: {
              id: 11,
              name: 'ozon.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/ozon_af00f6cdf0.png',
            },
          },
          {
            id: 2,
            href: 'https://www.rustore.ru/catalog/app/ru.rostel',
            isTargetBlank: false,
            Logo: {
              id: 14,
              name: 'gosuslugi.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/gosuslugi_1864ca586d.png',
            },
          },
          {
            id: 3,
            href: 'https://www.rustore.ru/catalog/app/ru.nspk.mirpay',
            isTargetBlank: false,
            Logo: {
              id: 19,
              name: 'mir.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/mir_d793c2f931.png',
            },
          },
          {
            id: 4,
            href: 'https://www.rustore.ru/catalog/app/com.vk.vkvideo',
            isTargetBlank: false,
            Logo: {
              id: 714,
              name: 'vk_video.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/vk_video_1ccac8ba52.png',
            },
          },
          {
            id: 6,
            href: 'https://www.rustore.ru/catalog/app/ru.mail.mailapp',
            isTargetBlank: false,
            Logo: {
              id: 3130,
              name: 'Mail.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/Mail_652c632dad.png',
            },
          },
          {
            id: 5,
            href: 'https://www.rustore.ru/catalog/app/com.blinkmap.rs',
            isTargetBlank: false,
            Logo: {
              id: 225,
              name: 'Blink_App_Icon.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/Blink_App_Icon_b2a3ac91b3.png',
            },
          },
          {
            id: 7,
            href: 'https://www.rustore.ru/catalog/app/com.yandex.browser',
            isTargetBlank: false,
            Logo: {
              id: 13,
              name: 'yandex_browser.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/yandex_browser_bc580a187e.png',
            },
          },
          {
            id: 35,
            href: 'https://www.rustore.ru/catalog/app/ru.dublgis.dgismobile',
            isTargetBlank: false,
            Logo: {
              id: 241,
              name: '2GIS_app icon.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/2_GIS_app_icon_e65f7cf40d.png',
            },
          },
        ],
      },
      {
        id: 2,
        MarqueSpeed: 2,
        LogoWallLogo: [
          {
            id: 8,
            href: 'https://www.rustore.ru/catalog/app/com.allgoritm.youla',
            isTargetBlank: false,
            Logo: {
              id: 18,
              name: 'yula.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/yula_d3646df79e.png',
            },
          },
          {
            id: 9,
            href: 'https://www.rustore.ru/catalog/app/ru.alfabank.mobile.android',
            isTargetBlank: false,
            Logo: {
              id: 6,
              name: 'alfa_bank.png',
              url: 'https://static.rustore.ru/rustore-strapi/8/alfa_bank_c65e17f5ff.png',
            },
          },
          {
            id: 10,
            href: 'https://www.rustore.ru/catalog/app/ru.sberbankmobile',
            isTargetBlank: false,
            Logo: {
              id: 22,
              name: 'sber.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/sber_8354553273.png',
            },
          },
          {
            id: 11,
            href: 'https://www.rustore.ru/catalog/app/ru.megamarket.marketplace',
            isTargetBlank: false,
            Logo: {
              id: 63,
              name: 'SberMarket.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/Sber_Market_9071f0f89f.png',
            },
          },
          {
            id: 12,
            href: 'https://www.rustore.ru/catalog/app/com.idamob.tinkoff.android',
            isTargetBlank: false,
            Logo: {
              id: 1914,
              name: 'T-Bank_Icon.png',
              url: 'https://static.rustore.ru/rustore-strapi/7/T_Bank_Icon_2ad65b69c0.png',
            },
          },
          {
            id: 13,
            href: 'https://www.rustore.ru/catalog/app/ru.rt.video.app.mobile',
            isTargetBlank: false,
            Logo: {
              id: 3128,
              name: 'wink.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/wink_c01c37075e.png',
            },
          },
          {
            id: 14,
            href: 'https://www.rustore.ru/catalog/app/ru.more.play',
            isTargetBlank: false,
            Logo: {
              id: 3129,
              name: 'okko.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/okko_11093b9dd1.png',
            },
          },
          {
            id: 34,
            href: 'https://www.rustore.ru/catalog/app/com.vk.love',
            isTargetBlank: false,
            Logo: {
              id: 238,
              name: 'VK znakomstva_app icon.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/VK_znakomstva_app_icon_5358b68274.png',
            },
          },
        ],
      },
      {
        id: 4,
        MarqueSpeed: 1,
        LogoWallLogo: [
          {
            id: 15,
            href: 'https://www.rustore.ru/catalog/app/ru.beru.android',
            isTargetBlank: false,
            Logo: {
              id: 1932,
              name: 'Ya_Market_Icon.png',
              url: 'https://static.rustore.ru/rustore-strapi/7/Ya_Market_Icon_db6be4957c.png',
            },
          },
          {
            id: 16,
            href: 'https://www.rustore.ru/catalog/app/com.wildberries.ru',
            isTargetBlank: false,
            Logo: {
              id: 3131,
              name: 'WB.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/WB_a9123bdd41.png',
            },
          },
          {
            id: 17,
            href: 'https://www.rustore.ru/catalog/app/com.avito.android',
            isTargetBlank: false,
            Logo: {
              id: 10,
              name: 'avito.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/avito_9e69b42924.png',
            },
          },
          {
            id: 18,
            href: 'https://www.rustore.ru/catalog/app/com.tanksblitz',
            isTargetBlank: false,
            Logo: {
              id: 5246,
              name: 'Tanks_Blitz_Icon.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/Tanks_Blitz_Icon_b8e2b3a0ae.png',
            },
          },
          {
            id: 19,
            href: 'https://www.rustore.ru/catalog/app/ru.mts.mymts',
            isTargetBlank: false,
            Logo: {
              id: 29,
              name: 'mts.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/mts_6059fd5b1b.png',
            },
          },
          {
            id: 20,
            href: 'https://www.rustore.ru/catalog/app/ru.ok.android',
            isTargetBlank: false,
            Logo: {
              id: 26,
              name: 'odnoklassniki.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/odnoklassniki_436780aaac.png',
            },
          },
          {
            id: 21,
            href: 'https://www.rustore.ru/catalog/app/ru.yandex.yandexmaps',
            isTargetBlank: false,
            Logo: {
              id: 28,
              name: 'yandex_karti.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/yandex_karti_99583895c6.png',
            },
          },
          {
            id: 36,
            href: 'https://www.rustore.ru/catalog/app/com.icemobile.lenta.prod',
            isTargetBlank: false,
            Logo: {
              id: 237,
              name: 'Lenta_app icon.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/Lenta_app_icon_06c154fdcd.png',
            },
          },
        ],
      },
      {
        id: 3,
        MarqueSpeed: 0,
        LogoWallLogo: [
          {
            id: 22,
            href: 'https://www.rustore.ru/catalog/app/com.vkontakte.android',
            isTargetBlank: false,
            Logo: {
              id: 17,
              name: 'vk.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/vk_bef8f948e2.png',
            },
          },
          {
            id: 23,
            href: 'https://www.rustore.ru/catalog/app/ru.yandex.yandexnavi',
            isTargetBlank: false,
            Logo: {
              id: 33,
              name: 'yandex_navigator.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/yandex_navigator_aaed28c2cb.png',
            },
          },
          {
            id: 24,
            href: 'https://www.rustore.ru/catalog/app/com.deliveryclub',
            isTargetBlank: false,
            Logo: {
              id: 7,
              name: 'delivery_club.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/delivery_club_75ca82ecb8.png',
            },
          },
          {
            id: 25,
            href: 'https://www.rustore.ru/catalog/app/video.like.rustore',
            isTargetBlank: false,
            Logo: {
              id: 9,
              name: 'likee.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/likee_cbe1de4189.png',
            },
          },
          {
            id: 26,
            href: 'https://www.rustore.ru/catalog/app/ru.yandex.taxi',
            isTargetBlank: false,
            Logo: {
              id: 16,
              name: 'yandex_go.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/yandex_go_28f82f0312.png',
            },
          },
          {
            id: 27,
            href: 'https://www.rustore.ru/catalog/app/ru.sbcs.store',
            isTargetBlank: false,
            Logo: {
              id: 23,
              name: 'samokat.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/samokat_ed6fa41cff.png',
            },
          },
          {
            id: 28,
            href: 'https://www.rustore.ru/catalog/app/ru.tander.magnit',
            isTargetBlank: false,
            Logo: {
              id: 39,
              name: 'Magnit_App Icon.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/Magnit_App_Icon_fbf23e5a0b.png',
            },
          },
          {
            id: 37,
            href: 'https://www.rustore.ru/catalog/app/ru.nspk.sbpay',
            isTargetBlank: false,
            Logo: {
              id: 236,
              name: 'SBPay_app icon.png',
              url: 'https://static.rustore.ru/rustore-strapi/6/SB_Pay_app_icon_ace7d6683d.png',
            },
          },
        ],
      },
    ],
  },
  RuStoreOpenForm: {
    id: 1,
    title: '推荐您喜欢的应用程序',
    submitButtonText: 'Отправить',
    linkHint: 'Подойдет ссылка на APK файл или ссылка на любой ресурс',
    name: {
      id: 211,
      label: 'Название',
      placeholder: 'Как называется приложение',
      optional: false,
      inputName: 'name',
      isTextArea: false,
      minLength: 1,
      maxLength: 50,
      valueType: 'plaintext',
    },
    link: {
      id: 212,
      label: 'Ссылка на приложение',
      placeholder: 'Где можно найти приложение',
      optional: false,
      inputName: 'link',
      isTextArea: false,
      minLength: 1,
      maxLength: 200,
      valueType: 'url',
    },
    description: {
      id: 213,
      label: 'Краткое описание',
      placeholder: 'Расскажите о приложении',
      optional: false,
      inputName: 'description',
      isTextArea: true,
      minLength: 1,
      maxLength: 80,
      valueType: 'plaintext',
    },
    type: {
      id: 214,
      label: 'Тип',
      placeholder: 'type',
      optional: false,
      inputName: 'type',
      isTextArea: true,
      minLength: 1,
      maxLength: 200,
      valueType: 'plaintext',
    },
  },
  SitemapConfig: {
    id: 4,
    defaultPriority: null,
    defaultChangefreq: null,
    entries: [],
    exclusions: [
      {
        id: 1,
        path: '/offers/ad_info',
      },
      {
        id: 2,
        path: '/offers/ad_info_vtb',
      },
    ],
  },
  RedesignAdvantages: [
    {
      id: 34,
      title: '安全保障',
      subtitle: '应用程序审查和杀毒查验',
      backgroundColor: '#00B594',
      logo: {
        id: 543,
        name: 'shhit2_1_0fc52d0643.png',
        width: 240,
        height: 200,
        url: 'https://platform-s3.dev.rustore.devmail.ru/rustore-strapi-stage/shhit2_1_0fc52d0643_162ebe6957.png',
      },
      titleLogo: {
        id: 542,
        name: 'Frame_1321315620_a1063bf518.svg',
        width: 128,
        height: 24,
        url: 'https://platform-s3.dev.rustore.devmail.ru/rustore-strapi-stage/Frame_1321315620_a1063bf518_76e65a3419.svg',
      },
    },
    {
      id: 36,
      title: '应用程序无限制访问',
      subtitle: '所有的应用可以随手下载，从移动银行到热门游戏',
      backgroundColor: '#0077FF',
      logo: {
        id: 544,
        name: '32_3_1_07b06a45c4.png',
        width: 240,
        height: 194,
        url: 'https://platform-s3.dev.rustore.devmail.ru/rustore-strapi-stage/32_3_1_07b06a45c4_54d223801d.png',
      },
      titleLogo: null,
    },
    {
      id: 35,
      title: '便捷支付与订阅',
      subtitle: '通过卡、快速支付、手机话费等可以支付',
      backgroundColor: '#9339D1',
      logo: {
        id: 545,
        name: 'Group_1321315585_791f2f7b61.png',
        width: 240,
        height: 200,
        url: 'https://platform-s3.dev.rustore.devmail.ru/rustore-strapi-stage/Group_1321315585_791f2f7b61_bef34cabaf.png',
      },
      titleLogo: null,
    },
  ],
  RedesignAdvantagesInstruction: {
    id: 34,
    title: '扫二维码下载RuStore',
    subtitle: '支持的设备包括 \n',
    qrCode: {
      id: 563,
      name: 'qr-code.svg',
      width: 160,
      height: 160,
      url: 'https://platform-s3.dev.rustore.devmail.ru/rustore-strapi-stage/qr_code_fff39c62ec.svg',
    },
    OSList: [
      {
        id: 34,
        OSName: 'Android 7.0',
        OSIcon: {
          id: 541,
          name: 'Android_47785be0fa.svg',
          width: 28,
          height: 28,
          size: 1.66,
          url: 'https://platform-s3.dev.rustore.devmail.ru/rustore-strapi-stage/Android_47785be0fa_07bd94a084.svg',
        },
      },
      {
        id: 35,
        OSName: 'Harmony OS 3',
        OSIcon: {
          id: 540,
          name: 'HMOS_Logo_Icon_08fde76bf0.svg',
          width: 24,
          height: 24,
          url: 'https://platform-s3.dev.rustore.devmail.ru/rustore-strapi-stage/HMOS_Logo_Icon_08fde76bf0_51b2e3f7d0.svg',
        },
      },
    ],
  },
  GamesOfTheMonth: {
    id: 1,
    gamesSelections:
      'com.tanksblitz,com.roblox.client,com.jcg.Boysword,com.matreshkarp.game,com.yandex.plus.game.city,com.rstgames.durak.rustore,com.gamemisctop.busSimulator3D,com.jetliberty.san_andreas_city_police_car,com.animan_publishing.diamond_dungeon,com.ZtepGC.EscapeFr',
    title: '本月热门游戏',
    buttonText: '所有游戏',
    backgroundImage: {
      id: 1572,
      name: 'Image (4).jpg',
      width: 2784,
      height: 1600,
      url: 'https://static.rustore.ru/rustore-strapi/6/Image_4_6a2a1bc0e7.jpg',
    },
  },
  TVBlock: {
    id: 34,
    title: 'RuStore的电视版',
    subtitle: '电视频道应用程序、流媒体服务、游戏和视频会议程序',
    buttonText: '下载RuStore的电视版',
    targetBlankButton: false,
    buttonHref: 'https://www.rustore.ru/tv',
    backgroundImage: {
      id: 575,
      name: '23 3.svg',
      width: 240,
      height: 200,
      url: 'https://platform-s3.dev.rustore.devmail.ru/rustore-strapi-stage/23_3_4de4bff2c1.svg',
    },
    tvApps: [
      {
        id: 35,
        href: 'https://www.rustore.ru/catalog/app/com.vk.tvt',
        isTargetBlank: false,
        backgroundImage: {
          id: 566,
          name: 'Rectangle 7.svg',
          width: 224,
          height: 128,
          url: 'https://static.rustore.ru/rustore-strapi/6/VK_a79aa8327f.png',
        },
      },
      {
        id: 36,
        href: 'https://www.rustore.ru/catalog/app/ru.ivi.client',
        isTargetBlank: false,
        backgroundImage: {
          id: 568,
          name: 'image 261 (1).svg',
          width: 224,
          height: 128,
          url: 'https://static.rustore.ru/rustore-strapi/7/ivi_705787e240.png',
        },
      },
      {
        id: 39,
        href: 'https://www.rustore.ru/catalog/app/ru.kinopoisk.tv',
        isTargetBlank: false,
        backgroundImage: {
          id: 566,
          name: 'Rectangle 7.svg',
          width: 224,
          height: 128,
          url: 'https://static.rustore.ru/rustore-strapi/8/Aspect_Ratio_d7e3065797.png',
        },
      },
      {
        id: 40,
        href: 'https://www.rustore.ru/catalog/app/one.premier.rustoretv',
        isTargetBlank: false,
        backgroundImage: {
          id: 565,
          name: 'Rectangle 2.svg',
          width: 224,
          height: 128,
          url: 'https://static.rustore.ru/rustore-strapi/6/premier_e0bb75fa82.png',
        },
      },
      {
        id: 38,
        href: 'https://www.rustore.ru/catalog/app/tv.okko.androidtv',
        isTargetBlank: false,
        backgroundImage: {
          id: 566,
          name: 'Rectangle 7.svg',
          width: 224,
          height: 128,
          url: 'https://static.rustore.ru/rustore-strapi/6/okko_cd0f5b702b.png',
        },
      },
    ],
  },
  searchBlock: {
    id: 3,
    title: '找到您需要的应用程序',
    placeholder: '搜索应用程序和游戏',
    searchButtonText: '查找',
    clearHistoryButton: 'Clear history',
  },
};
